import React, { useEffect, useRef } from "react";
import { Flex } from "@chakra-ui/react";

const AdId = '23327012697';

function Ad({ token, location, slot }) {

  const adUnitPath = `/${AdId}/${slot}`;

  const horizontalTop = [[1050, 230], [1050, 180],[970, 250], [960, 320], [960, 230]];
  const horizontalBase = [[970, 90], [960, 180], [920, 120], [790, 120], [728, 90]];
  const horizontalHeader = [...horizontalTop,...horizontalBase];
  const verticalText = [[300, 600], [300, 300], [300, 250], [300, 150], [300, 120], [250, 250]];
  const verticalSquare = [...verticalText];


  // temp to Estado
  const verticalText1 = [[300, 600]];
  const verticalText2 = [[300, 300], [300, 250], [300, 150], [300, 120], [250, 250]];

  const locSizes = {
    'super-topo': [
      { viewport: [970, 0], sizes: horizontalHeader },
      { viewport: [0, 0], sizes: verticalSquare }
    ],
    'topo': [
      { viewport: [970, 0], sizes: horizontalHeader },
      { viewport: [0, 0], sizes: verticalSquare }
    ],
    'horizontal': [
      { viewport: [970, 0], sizes: horizontalBase },
      { viewport: [0, 0], sizes: verticalSquare }
    ],
    'superior': [
      { viewport: [970, 0], sizes: horizontalBase },
      { viewport: [0, 0], sizes: verticalSquare }
    ],
    'inferior': [
      { viewport: [970, 0], sizes: horizontalBase },
      { viewport: [0, 0], sizes: verticalSquare }
    ],
    'lateral': [
      { viewport: [0, 0], sizes: verticalSquare }
    ],
    'texto': [
      { viewport: [970, 0], sizes: verticalText1 },
      { viewport: [0, 0], sizes: verticalText2 }
    ],
    'rodape-fixo': [
      { viewport: [970, 0], sizes: horizontalBase },
      { viewport: [0, 0], sizes: verticalSquare }
    ],
  }

  if(typeof locSizes[location] === 'undefined') {
    console.warn("Sem nehuma configurações de anúncio para a localização:", location);
    return null;
  }

  if(!slot.includes(location)) {
    console.warn("Não há disponibilidade de espaço na localização x slot", location + '_' + slot);
    return null;
  }

  const divId = `div-gpt-${token}`;

  const responsiveSizes= locSizes[location];

  const adSlotRef = useRef(null);
  const adContainerRef = useRef(null);

  useEffect(() => {
    const { googletag } = window;

    if (!googletag) {
      console.warn("Google Ad Manager script (gpt.js) não foi carregado. Verifique seu _app.js ou layout principal.");
      return;
    }

    if (!adContainerRef.current) {
      console.warn(`[AdManager] O elemento DIV para o slot '${divId}' ainda não está disponível no DOM.`);
      return;
    }

    googletag.cmd.push(function() {
      if (adSlotRef.current) {
        googletag.destroySlots([adSlotRef.current]);
        adSlotRef.current = null;
      }

      if (adContainerRef.current.id !== divId) {
          console.error(`[AdManager] Mismatch de ID: Ref ID '${adContainerRef.current.id}' vs esperado '${divId}'. Verifique a prop 'token'.`);
          return;
      }

      const sizeMapping = googletag.sizeMapping();

      if (responsiveSizes && responsiveSizes.length > 0) {
        responsiveSizes.forEach(mapping => {
          sizeMapping.addSize(mapping.viewport, mapping.sizes);
        });
      } else {
        console.warn(`Nenhum 'responsiveSizes' fornecido para o slot ${slot}. O anúncio pode não ser responsivo.`);
      }

      const builtSizeMapping = sizeMapping.build();

      const adSlot = googletag
        .defineSlot(adUnitPath, responsiveSizes[0]?.sizes[0] || [[1,1]], divId)
        .defineSizeMapping(builtSizeMapping)
        .addService(googletag.pubads());

      adSlotRef.current = adSlot;

      setTimeout(() => {
          googletag.display(divId);
      }, 0);

      return () => {
        googletag.cmd.push(function() {
          if (adSlotRef.current) { // Verifica novamente se o slot ainda existe
            googletag.destroySlots([adSlotRef.current]);
            console.log(`Ad slot ${divId} destruído.`);
            adSlotRef.current = null; // Limpa a referência
          }
        });
      };
    });

  }, [slot, adUnitPath, responsiveSizes, divId]);

  return (
    <Flex ref={adContainerRef} id={divId} justifyContent="center" overflow="hidden" className={location}>
      { /* O conteúdo do anúncio será injetado aqui pelo GPT */ }
    </Flex>
  );
}

export default Ad;






